export default __webpack_public_path__ + "static/media/Ring.6242312d.mp3";